import { View, Text, styled, ScrollView } from 'tamagui'

const Container = styled(View, { flex: 1, flexDirection: 'column' })
const Header = styled(View, { paddingHorizontal: 32, paddingVertical: 20, borderBottomWidth: 1, borderBottomColor: '$borderDefault' })
const Title = styled(Text, { fontFamily: '$fontHeading', fontWeight: '600', fontSize: 20, color: '$surfaceForeground' })
const Body = styled(View, { padding: 32, gap: 8, maxWidth: 600 })

const KeybindRow = styled(View, {
  flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
  height: 44, paddingHorizontal: 12, borderRadius: '$borderRadiusMd',
  hoverStyle: { backgroundColor: '$sidebarHover' },
})

const KeyLabel = styled(Text, { fontFamily: '$fontBody', fontSize: 14, color: '$surfaceForeground' })

const KeyCombo = styled(View, { flexDirection: 'row', alignItems: 'center', gap: 4 })

const Key = styled(View, {
  backgroundColor: '$sidebarActive', borderRadius: '$borderRadiusSm', paddingHorizontal: 8, paddingVertical: 4,
  borderWidth: 1, borderColor: '$borderDefault',
})

const KeyText = styled(Text, { fontFamily: '$fontMono', fontSize: 12, color: '$sidebarMuted' })

const keybinds = [
  { action: 'Command Palette', keys: ['⌘', 'K'] },
  { action: 'Toggle Mute', keys: ['⌘', 'Shift', 'M'] },
  { action: 'Toggle Deafen', keys: ['⌘', 'Shift', 'D'] },
  { action: 'Search', keys: ['⌘', 'F'] },
  { action: 'Navigate Up', keys: ['Alt', '↑'] },
  { action: 'Navigate Down', keys: ['Alt', '↓'] },
  { action: 'Close Panel', keys: ['Esc'] },
  { action: 'Mark as Read', keys: ['Shift', 'Esc'] },
  { action: 'Edit Last Message', keys: ['↑'] },
  { action: 'Reply', keys: ['⌘', 'Shift', 'R'] },
]

export function KeybindSettings() {
  return (
    <Container>
      <Header><Title>Keybinds</Title></Header>
      <ScrollView flex={1}>
        <Body>
          {keybinds.map((kb) => (
            <KeybindRow key={kb.action}>
              <KeyLabel>{kb.action}</KeyLabel>
              <KeyCombo>
                {kb.keys.map((key, i) => (
                  <View key={i} flexDirection="row" alignItems="center" gap={2}>
                    {i > 0 && <Text fontSize={11} color="$color8">+</Text>}
                    <Key><KeyText>{key}</KeyText></Key>
                  </View>
                ))}
              </KeyCombo>
            </KeybindRow>
          ))}
        </Body>
      </ScrollView>
    </Container>
  )
}
